import React from 'react';
import { FaGithub } from 'react-icons/fa';
import Layout from '../components/Layout';

function Projects() {
  return (
    <Layout maxWidth="max-w-8xl" bg="bg-primary-light dark:bg-primary-dark">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
        {/* Software Development Track */}
        <div className="space-y-8">
          <h2 className="sticky top-0 z-20 bg-primary-light dark:bg-primary-dark text-3xl font-bold text-gray-800 dark:text-white mb-12 flex items-center py-4">
            <span className="text-gray-800 dark:text-white">
              Software Development
            </span>
          </h2>

          <div className="rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow transform hover:-translate-y-1 duration-300 bg-gray-50 dark:bg-gray-800">
            <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Microservices E-Commerce Platform</h3>
            <div className="border-l-4 border-gray-500 pl-6 mb-6">
              <p className="text-gray-600 dark:text-gray-300 text-lg">
                A scalable StubHub-like ticketing platform built with microservices architecture, featuring JWT authentication and event-driven caching.
              </p>
            </div>
            <div className="space-y-6">
              <div className="bg-white/50 dark:bg-gray-700/50 rounded-lg p-4">
                <p className="text-gray-700 dark:text-gray-200 font-semibold mb-2">Technologies</p>
                <div className="flex flex-wrap gap-2">
                  <span className="px-3 py-1 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-full text-sm">TypeScript</span>
                  <span className="px-3 py-1 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-full text-sm">Next.js</span>
                  <span className="px-3 py-1 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-full text-sm">Node.js</span>
                  <span className="px-3 py-1 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-full text-sm">MongoDB</span>
                  <span className="px-3 py-1 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-full text-sm">Redis</span>
                  <span className="px-3 py-1 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-full text-sm">Docker</span>
                  <span className="px-3 py-1 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-full text-sm">Kubernetes</span>
                </div>
              </div>
              <div>
                <p className="text-gray-700 dark:text-gray-200 font-semibold mb-3">Key Features</p>
                <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 space-y-2 ml-4">
                  <li>JWT authentication with 15-minute token expiration for enhanced security</li>
                  <li>Server-side rendering with Next.js for optimal performance</li>
                  <li>Event-driven caching architecture for scalable user access control</li>
                  <li>Cloud-native deployment with Docker, Kubernetes, and Skaffold CI/CD</li>
                  <li>JMeter load testing: 95th percentile response &lt; 200ms, 99.9% success rate</li>
                </ul>
              </div>
              <div className="flex gap-4 mt-6">
                <a
                  href="https://github.com/ShqiW/microservices-ecommerce"
                  className="flex items-center gap-2 text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-300 transition-colors"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaGithub size={20} />
                  <span>View Source</span>
                </a>
              </div>
            </div>
          </div>

          <div className="rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow transform hover:-translate-y-1 duration-300 bg-gray-50 dark:bg-gray-800">
            <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Custom CI/CD System</h3>
            <div className="border-l-4 border-gray-500 pl-6 mb-6">
              <p className="text-gray-600 dark:text-gray-300 text-lg">
                A multi-module CI/CD system with Spring Boot backend and worker nodes executing parallel jobs in containerized environments.
              </p>
            </div>
            <div className="space-y-6">
              <div className="bg-white/50 dark:bg-gray-700/50 rounded-lg p-4">
                <p className="text-gray-700 dark:text-gray-200 font-semibold mb-2">Technologies</p>
                <div className="flex flex-wrap gap-2">
                  <span className="px-3 py-1 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-full text-sm">Java</span>
                  <span className="px-3 py-1 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-full text-sm">Spring Boot</span>
                  <span className="px-3 py-1 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-full text-sm">RabbitMQ</span>
                  <span className="px-3 py-1 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-full text-sm">Docker</span>
                  <span className="px-3 py-1 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-full text-sm">Kubernetes</span>
                  <span className="px-3 py-1 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-full text-sm">PostgreSQL</span>
                </div>
              </div>
              <div>
                <p className="text-gray-700 dark:text-gray-200 font-semibold mb-3">Key Features</p>
                <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 space-y-2 ml-4">
                  <li>Multi-module architecture with parallel job execution</li>
                  <li>CLI tool with YAML-based pipeline configuration</li>
                  <li>Multi-stage builds with job dependency management</li>
                  <li>Message queue architecture using RabbitMQ for backend-worker communication</li>
                  <li>Comprehensive reporting system tracking execution status across pipeline levels</li>
                </ul>
              </div>
              <div className="flex gap-4 mt-6">
                <a
                  href="https://github.com/ShqiW/cicd-system"
                  className="flex items-center gap-2 text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-300 transition-colors"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaGithub size={20} />
                  <span>View Source</span>
                </a>
              </div>
            </div>
          </div>

          <div className="rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow transform hover:-translate-y-1 duration-300 bg-gray-50 dark:bg-gray-800">
            <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Distributed Ski Resort Data System</h3>
            <div className="border-l-4 border-gray-500 pl-6 mb-6">
              <p className="text-gray-600 dark:text-gray-300 text-lg">
                A cloud-native distributed system handling 10K concurrent requests with optimized caching and auto-scaling capabilities.
              </p>
            </div>
            <div className="space-y-6">
              <div className="bg-white/50 dark:bg-gray-700/50 rounded-lg p-4">
                <p className="text-gray-700 dark:text-gray-200 font-semibold mb-2">Technologies</p>
                <div className="flex flex-wrap gap-2">
                  <span className="px-3 py-1 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-full text-sm">Java</span>
                  <span className="px-3 py-1 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-full text-sm">AWS EC2</span>
                  <span className="px-3 py-1 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-full text-sm">DynamoDB</span>
                  <span className="px-3 py-1 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-full text-sm">Redis</span>
                  <span className="px-3 py-1 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-full text-sm">AWS SQS</span>
                  <span className="px-3 py-1 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-full text-sm">JMeter</span>
                </div>
              </div>
              <div>
                <p className="text-gray-700 dark:text-gray-200 font-semibold mb-3">Performance Achievements</p>
                <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 space-y-2 ml-4">
                  <li>10K/5K req/sec throughput (POST/GET) with 25-40ms/5-10ms latency</li>
                  <li>AWS Auto Scaling handling 10K concurrent requests</li>
                  <li>85% cache hit rate with ElastiCache Redis reducing DynamoDB reads by 70%</li>
                  <li>99.9% message delivery through SQS with dead letter queues</li>
                  <li>Sub-10ms response time with optimized caching strategies</li>
                </ul>
              </div>
              <div className="flex gap-4 mt-6">
                <a
                  href="https://github.com/ShqiW/ski-resort-system"
                  className="flex items-center gap-2 text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-300 transition-colors"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaGithub size={20} />
                  <span>View Source</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* AI & Machine Learning Track */}
        <div className="space-y-8">
          <h2 className="sticky top-0 z-20 bg-primary-light dark:bg-primary-dark text-3xl font-bold text-gray-800 dark:text-white mb-12 flex items-center py-4">
            <span className="text-gray-800 dark:text-white">
              AI & Machine Learning
            </span>
          </h2>

       

          <div className="rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow transform hover:-translate-y-1 duration-300 bg-gray-50 dark:bg-gray-800">
            <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Intelligent Customer Service Agent System</h3>
            <div className="border-l-4 border-gray-500 pl-6 mb-6">
              <p className="text-gray-600 dark:text-gray-300 text-lg">
                AI competition project: Multi-Agent customer service system integrating structured and unstructured data to address low FAQ hit rates and poor multi-hop reasoning.
              </p>
            </div>
            <div className="space-y-6">
              <div className="bg-white/50 dark:bg-gray-700/50 rounded-lg p-4">
                <p className="text-gray-700 dark:text-gray-200 font-semibold mb-2">Technologies</p>
                <div className="flex flex-wrap gap-2">
                  <span className="px-3 py-1 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-full text-sm">LangGraph</span>
                  <span className="px-3 py-1 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-full text-sm">DeepSeek v3</span>
                  <span className="px-3 py-1 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-full text-sm">Neo4j</span>
                  <span className="px-3 py-1 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-full text-sm">GraphRAG</span>
                  <span className="px-3 py-1 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-full text-sm">Map-Reduce</span>
                  <span className="px-3 py-1 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-full text-sm">Few-shot Learning</span>
                </div>
              </div>
              <div>
                <p className="text-gray-700 dark:text-gray-200 font-semibold mb-3">Key Features & Achievements</p>
                <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 space-y-2 ml-4">
                  <li>Multi-Agent workflow: intent recognition, safety guardrails, planner decomposition, parallel tools, hallucination detection (Map-Reduce)</li>
                  <li>Optimized intent recognition with DeepSeek v3 and few-shot learning, F1 score improved from 0.82 to 0.93</li>
                  <li>Parallel retrieval system: Neo4j Text2Cypher + GraphRAG with Map-Reduce, query latency reduced from 4.8s to 2.1s</li>
                </ul>
              </div>
              <div className="flex gap-4 mt-6">
                <a
                  href="https://github.com/ShqiW/adhd-pdf-reader"
                  className="flex items-center gap-2 text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-300 transition-colors"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaGithub size={20} />
                  <span>View Source</span>
                </a>
              </div>
            </div>
          </div>


          <div className="rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow transform hover:-translate-y-1 duration-300 bg-gray-50 dark:bg-gray-800">
            <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              PickStock: Multi-Agent Financial Analysis Tool with Custom LLM
            </h3>
            <div className="border-l-4 border-gray-500 pl-6 mb-6">
              <p className="text-gray-600 dark:text-gray-300 text-lg">
                Multi-Agent financial analysis platform leveraging custom LLMs for parallel fundamental, technical, valuation, and news analysis.
              </p>
            </div>
            <div className="space-y-6">
              <div className="bg-white/50 dark:bg-gray-700/50 rounded-lg p-4">
                <p className="text-gray-700 dark:text-gray-200 font-semibold mb-2">Technologies</p>
                <div className="flex flex-wrap gap-2">
                  <span className="px-3 py-1 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-full text-sm">LangGraph</span>
                  <span className="px-3 py-1 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-full text-sm">LoRA</span>
                  <span className="px-3 py-1 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-full text-sm">GRPO</span>
                  <span className="px-3 py-1 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-full text-sm">vLLM</span>
                </div>
              </div>
              <div>
                <p className="text-gray-700 dark:text-gray-200 font-semibold mb-3">Key Features & Achievements</p>
                <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 space-y-2 ml-4">
                  <li>Built 4 specialized financial agents using LangGraph for parallel fundamental, technical, valuation, and news analysis</li>
                  <li>Fine-tuned Qwen3-1.7B with SFT + GRPO, achieving 85.0/76.0 scores on ConvFinQA/FinQA benchmarks</li>
                  <li>Developed sentiment/risk models via LoRA fine-tuning Qwen3-8B with hard negatives, achieving 91.2%/88.4% accuracy</li>
                  <li>Deployed with vLLM + INT8 quantization, achieving 2.5x speedup, 150 QPS, and 50ms response time</li>
                  <li>Implemented 7-dimensional evaluation framework for 60K+ samples with 99% data consistency and 78% accuracy</li>
                </ul>
              </div>
            </div>
          </div>


             {/* <div className="rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow transform hover:-translate-y-1 duration-300 bg-gray-50 dark:bg-gray-800">
            <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">LLM Response Formatting System</h3>
            <div className="border-l-4 border-gray-500 pl-6 mb-6">
              <p className="text-gray-600 dark:text-gray-300 text-lg">
                A Python-based system for processing and formatting Large-Language Model responses for enterprise workflow integration.
              </p>
            </div>
            <div className="space-y-6">
              <div className="bg-white/50 dark:bg-gray-700/50 rounded-lg p-4">
                <p className="text-gray-700 dark:text-gray-200 font-semibold mb-2">Technologies</p>
                <div className="flex flex-wrap gap-2">
                  <span className="px-3 py-1 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-full text-sm">Python</span>
                  <span className="px-3 py-1 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-full text-sm">Flask</span>
                  <span className="px-3 py-1 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-full text-sm">OpenAI API</span>
                  <span className="px-3 py-1 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-full text-sm">Pandas</span>
                </div>
              </div>
              <div>
                <p className="text-gray-700 dark:text-gray-200 font-semibold mb-3">Key Features</p>
                <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 space-y-2 ml-4">
                  <li>Human-in-the-loop reinforcement learning (HIRL) feedback model for LLM fine-tuning</li>
                  <li>Context-aware response generation using OpenAI API integration</li>
                  <li>Data preprocessing and transformation pipelines for downstream compatibility</li>
                  <li>Modular architecture supporting multiple formatting templates</li>
                  <li>Dynamic response customization based on workflow requirements</li>
                  <li>Comprehensive testing and validation for real-world scenario accuracy</li>
                </ul>
              </div>
              <div className="flex gap-4 mt-6">
                <a
                  href="https://github.com/ShqiW/llm-formatter"
                  className="flex items-center gap-2 text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-300 transition-colors"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaGithub size={20} />
                  <span>View Source</span>
                </a>
              </div>
            </div>
          </div> */}

          <div className="rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow transform hover:-translate-y-1 duration-300 bg-gray-50 dark:bg-gray-800">
            <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">ADHD-Friendly PDF Reader</h3>
            <div className="border-l-4 border-gray-500 pl-6 mb-6">
              <p className="text-gray-600 dark:text-gray-300 text-lg">
                Hackathon project enhancing readability for ADHD users through AI-powered visual formatting on SnapDragon devices.
              </p>
            </div>
            <div className="space-y-6">
              <div className="bg-white/50 dark:bg-gray-700/50 rounded-lg p-4">
                <p className="text-gray-700 dark:text-gray-200 font-semibold mb-2">Technologies</p>
                <div className="flex flex-wrap gap-2">
                  <span className="px-3 py-1 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-full text-sm">Python</span>
                  <span className="px-3 py-1 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-full text-sm">React.js</span>
                  <span className="px-3 py-1 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-full text-sm">AnythingLLM</span>
                  <span className="px-3 py-1 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-full text-sm">SnapDragon</span>
                </div>
              </div>
              <div>
                <p className="text-gray-700 dark:text-gray-200 font-semibold mb-3">Features & Recognition</p>
                <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 space-y-2 ml-4">
                  <li>Syllable bolding and highlighting for improved readability</li>
                  <li>Visual data framing optimized for ADHD users</li>
                  <li>On-device AI processing using SnapDragon capabilities</li>
                  <li>Qualcomm & Microsoft On-Device AI Builders Hackathon (April 2025)</li>
                </ul>
              </div>
              <div className="flex gap-4 mt-6">
                <a
                  href="https://github.com/ShqiW/adhd-pdf-reader"
                  className="flex items-center gap-2 text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-300 transition-colors"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaGithub size={20} />
                  <span>View Source</span>
                </a>
              </div>
            </div>
          </div>


          
        </div>
      </div>
    </Layout>
  );
}

export default Projects;